module.exports = __webpack_public_path__ + "img/V-63-ST-1500-BE.321bc9ae.png";